import { useMatch } from 'react-router-dom';

export function useMatchRoute(route: string) {
  return !!useMatch(route);
}
